// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".inputss[data-v-2aaff6a4]{width:25rem;height:3.75rem;margin-top:1.5625rem;margin-left:20%;border-radius:.3125rem;border:.0625rem solid#DCDFE6}.bss[data-v-2aaff6a4]{margin-top:.625rem;margin-left:28%}", ""]);
// Exports
module.exports = exports;
